/* global HTMLFieldSetElement */
// Ref: https://thoughtbot.com/blog/dynamic-forms-with-stimulus

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    const checkedRadio = this.element.querySelector('input[type=radio]:checked')

    if (checkedRadio) {
      this.enable({ target: checkedRadio })
    }
  }

  enable ({ target }) {
    const allFieldsets = controlledElements(...this.element.querySelectorAll('input[type=radio]'))

    for (const fieldset of allFieldsets) {
      if (fieldset instanceof HTMLFieldSetElement) fieldset.disabled = true
    }

    for (const fieldset of controlledElements(target)) {
      if (fieldset instanceof HTMLFieldSetElement) fieldset.disabled = false

      const selects = fieldset.querySelectorAll('select')
      for (const select of selects) {
        select.removeAttribute('disabled')

        const choicesController = select.closest('[data-controller~="choices"]')?.choices
        if (choicesController?.choices?.disable) {
          choicesController.choices.enable()
        } else if (!choicesController?.choices) {
          choicesController?.setup?.()
        }
      }

      const inputs = fieldset.querySelectorAll('input')
      for (const input of inputs) {
        input.removeAttribute('disabled')
      }
    }
  }
}

function controlledElements (...selectedElements) {
  return selectedElements.flatMap(selectedElement =>
    getElementsByTokens(selectedElement.getAttribute('aria-controls'))
  )
}

function getElementsByTokens (tokens) {
  const ids = (tokens ?? '').split(/\s+/)
  const elements = ids.map(id => document.getElementById(id)).filter(Boolean)

  return elements
}
